import React from "react";
import Button from "./elements/button";
import Icon from "./icons";
interface CameraProps {
    onCancel?: () => void;
    onSubmit?: (data: { file: File, uridata: string }) => void;
}
const Camera: React.FC<CameraProps> = ({ onCancel = () => { }, onSubmit = (data) => { } }) => {
    const campreviewRef: any = React.useRef(null);
    const canvasRef: any = React.useRef();

    const [stream, setStream] = React.useState<any>(null);
    const [facing, setFacing] = React.useState<string>(`user`);
    const [error, setError] = React.useState<string | null>(``);
    const [strictMode, setStrictMode] = React.useState<string>(`strict`);
    const [previewImg, setPreviewImg] = React.useState<string>(``);

    const takeSnap = async () => {
        if (canvasRef.current && campreviewRef.current) {
            const ctx = canvasRef.current.getContext('2d');
            const videoRatio = campreviewRef.current.videoWidth / campreviewRef.current.videoHeight;
            const targetRatio = 16 / 9; // change ratio here (e.g., 4/3, 1/1, etc.)
            let sx, sy, sWidth, sHeight;
            if (videoRatio > targetRatio) {
                // video is wider → crop width
                sHeight = campreviewRef.current.videoHeight;
                sWidth = sHeight * targetRatio;
                sx = (campreviewRef.current.videoWidth - sWidth) / 2;
                sy = 0;
            } else {
                // video is taller → crop height
                sWidth = campreviewRef.current.videoWidth;
                sHeight = sWidth / targetRatio;
                sx = 0;
                sy = (campreviewRef.current.videoHeight - sHeight) / 2;
            }
            // set canvas size according to target ratio
            canvasRef.current.width = 800;  // output width
            canvasRef.current.height = 800 / targetRatio; // output height
            // draw cropped video into canvas            
            if (facing === `user`) {
                console.log("Flipping horizantally..");
                // Flip horizontally
                ctx.translate(canvasRef.current.width, 0);
                ctx.scale(-1, 1);
                ctx.drawImage(campreviewRef.current, sx, sy, sWidth, sHeight, 0, 0, canvasRef.current.width, canvasRef.current.height);
                ctx.setTransform(1, 0, 0, 1, 0, 0);
            } else {
                ctx.drawImage(campreviewRef.current, sx, sy, sWidth, sHeight, 0, 0, canvasRef.current.width, canvasRef.current.height);
            }
            //ctx.drawImage(campreviewRef.current, 0, 0, canvasRef.current.width, campreviewRef.current.height);
            const dataURL = canvasRef.current.toDataURL("image/png");
            setPreviewImg(dataURL);
        }
    }

    const randomString = (length = 4): string => {
        const chars = "abcdefghijklmnopqrstuvwxyz";
        let result = "";
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * chars.length);
            result += chars[randomIndex];
        }
        return result;
    }

    const retakeSnap = () => {
        setPreviewImg(``);
        setError(``);
        init_page();
    };

    const closeModalx = () => {
        if (stream) {
            stream.getTracks().forEach((track: any) => track.stop());
        }
        onCancel();
    }

    const base64ToBinary = (base64Data: any) => {
        const cleaned = base64Data.replace(/^data:image\/\w+;base64,/, "");
        // Decode base64 to raw binary string
        const binaryString = atob(cleaned);
        // Convert binary string to Uint8Array
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }

    const processImageFile = () => {
        if (previewImg) {
            const binaryData = base64ToBinary(previewImg);
            // Optionally wrap in File (useful for uploads)
            const preparedFile = new File([binaryData], `CAM_${randomString(4)}_${Date.now()}.png`, { type: "image/png" });
            console.log("Snap Image File -> ", preparedFile);
            onSubmit({ file: preparedFile, uridata: previewImg });
            try {
                if (stream) {
                    stream.getTracks().forEach((track: any) => track.stop());
                }
            } catch (errx) {
                console.log("Camera Process Error is ->", errx)
            }
        }
    };


    const init_page = async (face = facing) => {
        if (stream) {
            stream.getTracks().forEach((track: any) => track.stop());
        }
        var streamx = null;
        try {
            streamx = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: {
                        exact: face
                    }
                }
            });
        } catch (err: any) {
            if (err.name === "OverconstrainedError") {
                streamx = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: {
                            ideal: face
                        }
                    }
                });
            } else {
                console.error("Error accessing camera:", err);
                setError(`Camera not available or permission denied.`);
            }
        }
        setStream(streamx);
        const track = streamx?.getVideoTracks()[0];
        const settings = track?.getSettings();
        if (settings?.facingMode) {
            setFacing(settings.facingMode);
        }
        if (campreviewRef.current && streamx) {
            campreviewRef.current.srcObject = streamx;
        }
    };

    React.useEffect(() => {
        init_page()
    }, []);

    return (
        <div className={`relative`}>
            <h4 className={`font-bold text-lg pl-0 pr-0 mb-4 modal-header`}>Camera</h4>
            <form className={`flex flex-col min-h-[50vh]`}>
                <div className={`relative`}>
                    <select className={`absolute text-sm p-0 right-2 top-2 text-black bg-white bg-opacity-80 font-normal outline-none border border-blue-500 rounded-sm shadow-none px-3 py-0.5 w-20 z-10`} onChange={(e: any) => {
                        setFacing(e.target.value);
                        setError(``);
                        init_page(e.target.value);
                    }}>
                        <option value={`user`} selected={facing === `front`}>Front</option>
                        <option value={`environment`} selected={facing === `environment`}>Back</option>
                    </select>
                    {error ? (
                        <div className={`bg-black flex items-center justify-center h-[175px] grow rounded`}>
                            <div className={`flex flex-col items-center justify-center bg-white bg-opacity-70 text-red-600 font-normal p-3 rounded`}>
                                <Icon name={`warning`} size={1.4} />
                                <div>{error}</div>
                            </div>
                        </div>
                    ) : (
                        <div className={`bg-black flex items-center justify-center h-full grow rounded`}>
                            <video ref={campreviewRef} className={`object-cover rounded h-[50vh] ${facing === `user`? `-scale-x-100` : ``} ${previewImg ? `hidden` : ``}`} id="video" autoPlay playsInline width="100%"></video>
                            <img src={previewImg} className={` w-full h-[50vh] ${!previewImg ? `hidden` : ``}`} />
                        </div>
                    )}
                </div>
                <canvas ref={canvasRef} id="canvas" height="100%" className={`w-full hidden absolute top-0 left-0 bottom-0 right-0 pointer-events-none`}></canvas>
                <div className={`flex justify-end gap-2 mt-4`}>
                    <Button type="button" theme={`secondary`} onClick={() => {
                        closeModalx();
                    }}>Cancel</Button>
                    <Button type="button" className={`${previewImg || error ? `hidden` : ``}`} onClick={() => {
                        takeSnap();
                    }}>Snap it</Button>
                    <Button type="button" className={`${!previewImg || error ? `hidden` : ``}`} onClick={() => {
                        retakeSnap();
                    }}>Retake</Button>
                    <Button type="button" className={`${!previewImg || error ? `hidden` : ``}`} onClick={() => {
                        processImageFile();
                    }}>Submit</Button>
                </div>
            </form >
        </div >
    )
}

export default Camera;